import { PREFIXES } from '../../../actionTypePrefixes'

export const FETCH_POLICY_CATEGORIES_TRIGGER = `${PREFIXES.TRIGGER}:FETCH_POLICY_CATEGORIES`
export const FETCH_POLICY_CATEGORIES_REQUEST = `${PREFIXES.REQUEST}:FETCH_POLICY_CATEGORIES`
export const FETCH_POLICY_CATEGORIES_SUCCESS = `${PREFIXES.SUCCESS}:FETCH_POLICY_CATEGORIES`
export const FETCH_POLICY_CATEGORIES_FAILURE = `${PREFIXES.FAILURE}:FETCH_POLICY_CATEGORIES`
export const FETCH_POLICY_CATEGORIES_FULFILL = `${PREFIXES.FULFILL}:FETCH_POLICY_CATEGORIES`

export const FETCH_POLICY_TYPES_TRIGGER = `${PREFIXES.TRIGGER}:FETCH_POLICY_TYPES`
export const FETCH_POLICY_TYPES_REQUEST = `${PREFIXES.REQUEST}:FETCH_POLICY_TYPES`
export const FETCH_POLICY_TYPES_SUCCESS = `${PREFIXES.SUCCESS}:FETCH_POLICY_TYPES`
export const FETCH_POLICY_TYPES_FAILURE = `${PREFIXES.FAILURE}:FETCH_POLICY_TYPES`
export const FETCH_POLICY_TYPES_FULFILL = `${PREFIXES.FULFILL}:FETCH_POLICY_TYPES`

export const FETCH_COUNTRIES_TRIGGER = `${PREFIXES.TRIGGER}:FETCH_COUNTRIES`
export const FETCH_COUNTRIES_REQUEST = `${PREFIXES.REQUEST}:FETCH_COUNTRIES`
export const FETCH_COUNTRIES_SUCCESS = `${PREFIXES.SUCCESS}:FETCH_COUNTRIES`
export const FETCH_COUNTRIES_FAILURE = `${PREFIXES.FAILURE}:FETCH_COUNTRIES`
export const FETCH_COUNTRIES_FULFILL = `${PREFIXES.FULFILL}:FETCH_COUNTRIES`

export const FETCH_OCCUPANCIES_TRIGGER = `${PREFIXES.TRIGGER}:FETCH_OCCUPANCIES`
export const FETCH_OCCUPANCIES_REQUEST = `${PREFIXES.REQUEST}:FETCH_OCCUPANCIES`
export const FETCH_OCCUPANCIES_SUCCESS = `${PREFIXES.SUCCESS}:FETCH_OCCUPANCIES`
export const FETCH_OCCUPANCIES_FAILURE = `${PREFIXES.FAILURE}:FETCH_OCCUPANCIES`
export const FETCH_OCCUPANCIES_FULFILL = `${PREFIXES.FULFILL}:FETCH_OCCUPANCIES`


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/constants/quote/step00/index.ts